module.exports = __webpack_public_path__ + "static/media/wireframe_yeutech-iphone.3a044f6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/wireframe_yeutech-iphone.png
// module id = 328
// module chunks = 0